import React from "react"

// Create an embedded Google Maps iframe component that doesn't require an API key
export const EmbeddedGoogleMap = ({
  position,
  address,
}: {
  position?: { lat: number; lng: number }
  address?: string
}) => {
  // Simple Google Maps sharing URL that doesn't require an API key
  const location = encodeURIComponent(position ? `${position.lat},${position.lng}` : address || '')
  const mapUrl = `https://www.google.com/maps?q=${location}&z=14&output=embed`

  return (
    <iframe
      title="Google Maps"
      width="100%"
      height="100%"
      style={{ border: 0 }}
      loading="lazy"
      src={mapUrl}
      allowFullScreen
    />
  )
}
